import CONST_SUB_GENRE from 'features/SubGenre/constans';
import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';

interface FilterProps {
  setName: (name: string) => void;
  setFairFlg: (fair_flg: number) => void;
  handleFilter: () => void;
  setDeleteFlg: (deleteFlg: number) => void;
  name: string;
  fairFlg: number;
  deleteFlg: number;
}

const deleteFlgString: any = {
  '0': '削除データのみ表示',
  '1': '削除データ非表示',
  '-1': '削除データ含めて表示',
};

const fairFlgString: any = {
  '0': 'なしのみ表示',
  '1': 'ありのみ表示',
  '-1': '全て',
};

function Filter({ setName, handleFilter, setFairFlg, setDeleteFlg, name, fairFlg, deleteFlg }: FilterProps) {
  const { t } = useTranslation();

  function handleChangeName(event: any) {
    setName(event.target.value);
  }

  function handleChangeFairFlg(event: any) {
    setFairFlg(event.target.value);
  }

  function handleChangeDelFlg(event: any) {
    setDeleteFlg(event.target.value);
  }
  return (
    <Form>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('MenuAddModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Row} className="mb-2">
              <div>
                <Form.Label column sm={1} md={1} lg={1} xl={1}>
                  {t('SubGenre.Filter.fair')}
                </Form.Label>
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_all')}
                  id="0"
                  defaultChecked={true}
                  onChange={handleChangeFairFlg}
                  name="fair_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.ALL}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_only_with')}
                  id="1"
                  onChange={handleChangeFairFlg}
                  name="fair_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.ONLY}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_none_only')}
                  id="2"
                  onChange={handleChangeFairFlg}
                  name="fair_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.NONE_ONLY}
                />
              </div>
            </Form.Group>

            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm={1} md={1} lg={1} xl={1}>
                {t('SubGenre.Filter.name')}
              </Form.Label>
              <Col sm={4} md={4} lg={4} xl={4}>
                <Form.Control type="text" onChange={handleChangeName} />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-0">
              <Form.Label column sm={1} md={1} lg={1} xl={1}>
                {t('SubGenre.Filter.delete_date')}
              </Form.Label>
              <Col sm={5} md={5} lg={5} xl={5} className="d-flex align-items-center">
                <Form.Check
                  inline
                  defaultChecked={true}
                  type="radio"
                  label={t('SubGenre.Filter.hide_del')}
                  id="3"
                  onChange={handleChangeDelFlg}
                  name="delete_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.HIDE_DEL}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_all_del')}
                  id="4"
                  onChange={handleChangeDelFlg}
                  name="delete_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.ALL}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_del')}
                  id="5"
                  onChange={handleChangeDelFlg}
                  name="delete_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.SHOW_DEL}
                />
              </Col>

              <Col sm={6} md={6} lg={6} xl={6} className="d-flex justify-content-end">
                <button type="button" className="btn btn-primary" onClick={handleFilter}>
                  {t('SubGenre.Button.search')}
                </button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('SubGenre.Filter.fair')} : {fairFlgString[fairFlg]}
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('SubGenre.Filter.name')} : {name}
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('SubGenre.Filter.delete_date')} : {deleteFlgString[deleteFlg]}
                </Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </Form>
  );
}

export default Filter;
